module.exports = __webpack_public_path__ + "26e5dc277eb72cfbabcdee94c7992f18.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_l_60.mp3
// module id = 449
// module chunks = 0